import React from "react";
import { useLang } from "@/context/LanguageContext";
import { T } from "@/content/site";

export default function Marquee() {
  const { t } = useLang();
  const words = t(T.marquee);
  const items = [...words, ...words, ...words];

  return (
    <section data-testid="marquee-section" aria-hidden="true" className="relative bg-[#0F0F0F] py-16 md:py-24 border-y border-white/5 overflow-hidden">
      <div className="marquee">
        <div className="marquee-track">
          {items.map((w, i) => (
            <span
              key={i}
              className="font-serif italic text-[80px] md:text-[140px] lg:text-[180px] leading-none text-transparent"
              style={{ WebkitTextStroke: "1px rgba(201,169,97,0.35)" }}
            >
              {w} <span className="text-[color:var(--sacrvm-gold)]/60 not-italic mx-6">·</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
